/* istanbul ignore file */
import { string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const FileRuleInputDataParser = /* #__PURE__ */ parsers.object([
    ['ruleType', /* #__PURE__ */ parsers.exactly('allow', 'deny', 'require'), 'rule_type'],
    ['fileType', /* #__PURE__ */ parsers.exactly('directory', 'file'), 'file_type'],
    ['name', codecString],
]);
export class FileRuleInputData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return FileRuleInputDataParser.decode(input).map(res => new FileRuleInputData(res));
    }
    static unsafeDecode(input) {
        return FileRuleInputData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return FileRuleInputDataParser.encode(data);
    }
    static schema() {
        return FileRuleInputDataParser.schema();
    }
}
